import { useCompanyQuery } from '../../../features/company/useCompanyQuery';
import { getFaviconUrl } from '../../../services/favicon';

import { StyledCompanyFavicon, StyledCompanyName } from './styles';

export const CompanyNameView = () => {
  const { data: company, isLoading } = useCompanyQuery();

  const domain = company?.domain;

  if (!domain || isLoading) {
    return <>Loading...</>;
  }

  const getFaviconSrc = () => getFaviconUrl(domain);

  return (
    <StyledCompanyName data-automation="InsightsCompanyName">
      <StyledCompanyFavicon src={getFaviconSrc()} data-automation="InsightsCompanyIcon" />
      <span>{company?.name || domain}</span>
    </StyledCompanyName>
  );
};
